const { DOC_TYPE_INFO } = require('@constants/articles/docTypes')

function categoryName (post) {
    const { docType = null } = post
    return (DOC_TYPE_INFO[docType] || {}).name
}

module.exports = { categoryName }